/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const deliveryStatusEnum = {
  pending: 'pending',
  sent: 'sent',
  delivered: 'delivered',
  read: 'read',
  failed: 'failed',
} as const;

export type DeliveryStatusEnumKey = (typeof deliveryStatusEnum)[keyof typeof deliveryStatusEnum];

export type DeliveryStatus = DeliveryStatusEnumKey | null;
